import React, { useEffect, useState } from "react";
import logo from "../img/easyILA_Logo.svg";
import logoLight from "../img/easyILA_Logo_White.svg";
import { Link } from "react-router-dom";
import Loader from "../components/loader";
import { Helmet } from "react-helmet-async";
import Navbar from "./Header/Navbar-1";
// import "../css/policy.css";
import Headers from "./Header";
import Footer from "./Footer";
import CollapseHeaders from "./collapse-header";

const NewTermsAndConditions = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageHeight = windowWidth <= 768 ? "50px" : "90px";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>Terms and Conditions - easyILA</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div>
        {/* Header Section */}
        <CollapseHeaders />

        {/* Terms of Use Agreement Start */}
        <div className="terms-and-conditions" style={{ paddingTop: "100px" }}>
          <div className="container">
            <div className="row video_main">
              <div className="col-md-12">
                <div className="row">
                  <h1 className="terms_heading">Terms of Use Agreement</h1>
                  <div class="col-lg-12">
                    <p class="terms_text">
                      THIS AGREEMENT REQUIRES THE USE OF ARBITRATION ON AN
                      INDIVIDUAL BASIS TO RESOLVE DISPUTES BETWEEN YOU AND
                      EASYILA, AND BOTH YOU AND EASYILA WAIVE THE RIGHT TO A
                      JURY TRIAL OR CLASS ACTION. PLEASE READ SECTION 14
                      CAREFULLY. IT AFFECTS YOUR LEGAL RIGHTS AND REMEDIES AND
                      WILL HAVE A SUBSTANTIAL EFFECT ON HOW DISPUTES BETWEEN YOU
                      AND EASYILA WILL BE RESOLVED.
                    </p>
                    <p class="terms_text">
                      The summaries of provisions under "One Liner" are provided
                      as a courtesy to help you understand this Agreement, but
                      they are not legally binding and do not modify this
                      Agreement in any way
                    </p>

                    <h2 class="terms_condition_1">Scope</h2>

                    <h2 class="terms_condition_1">1. Scope of Agreement</h2>
                    <p class="terms_text">
                      This Terms of Use Agreement ("Agreement") is between you
                      and esmsys LLC, EasyILA ("EasyILA"), and governs your use
                      of the website located at www.easyila.com (including all
                      subdomains) (the "Site") and the services provided by
                      EasyILA (the "Services"). By accessing or using the Site
                      or the Services, you agree to be legally bound by this
                      Agreement. Your use of the Site and Services is also
                      subject to the terms of the EasyILA{" "}
                      <a href="privacypolicy" style={{ color: "#0b83f6" }}>
                        Privacy Policy
                      </a>
                      . If you purchase Services that include independent
                      attorney review, your relationship with the independent
                      attorney will be governed by the Attorney Agreement . If
                      you do not agree to the terms of this Agreement and the{" "}
                      <a href="privacypolicy" style={{ color: "#0b83f6" }}>
                        Privacy Policy
                      </a>
                      , you may not access or use the Site or Services. The Site
                      and Services are intended for use by persons 18 years of
                      age or older. If you are under 18 years of age, you may
                      not access or use the Site or Services.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      If you use the EasyILA website or services, you are
                      agreeing to these terms. If you don't agree to the terms,
                      or if you are under 18 years of age, you may not use the
                      website or services.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Description of Services
                    </h2>

                    <h2 class="terms_condition_1">
                      2. Description of Services; No Affiliation with USCIS
                    </h2>
                    <p class="terms_text">
                      EasyILA is a platform designed to assist you in completing
                      United States Citizenship and Immigration Services (USCIS)
                      forms as well as forms required by other governmental
                      agencies, some of which may be of countries other than
                      USA. EasyILA provides information and step-by-step
                      instructions intended to make the completion of such forms
                      less confusing. EasyILA is not affiliated with or endorsed
                      by USCIS or any United States government agency or of any
                      country. All USCIS and other forms are available without
                      cost from USCIS and other applicable agencies. Similarly,
                      other countries may or may not be providing information
                      and forms without cost. Use of the EasyILA Site and
                      Services is not required to complete and file such forms.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      United States Citizenship and Immigration Services (USCIS)
                      is the government agency that oversees many U.S.
                      immigration benefits. USCIS provides immigration forms for
                      free. EasyILA is a private company and has no affiliation
                      with USCIS. You are not required to use EasyILA to
                      complete USCIS forms. Services and products that pertain
                      to countries other than USA do not require to use EasyILA
                      to apply or complete their respective procedures or forms.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Not a Law Firm
                    </h2>

                    <h2 class="terms_condition_1">
                      3. EasyILA is Not a Law Firm
                    </h2>
                    <p class="terms_text">
                      EASYILA IS NOT A LAW FIRM. SOME OF THE PEOPLE WHO OWN /
                      MANAGE THIS COMPANY ARE NOT LAWYERS. THIS MEANS THAT SOME
                      SERVICES / PROTECTIONS, LIKE ATTORNEY-CLIENT PRIVILEGE,
                      MAY BE DIFFERENT FROM THOSE YOU COULD GET FROM A LAW FIRM.
                      IF YOU HAVE QUESTIONS, PLEASE CONTACT OUR CUSTOMER CARE
                      CENTER AT SUPPORT@EASYILA.COM. IF YOU PURCHASE SERVICES
                      THAT INCLUDE INDEPENDENT ATTORNEY REVIEW, YOUR
                      RELATIONSHIP WITH THE INDEPENDENT ATTORNEY WILL BE
                      GOVERNED BY THE ATTORNEY AGREEMENT.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      EasyILA is not a law firm and by purchasing services, you
                      are not engaging an attorney. Depending on your particular
                      circumstances, you may require the services of a licensed
                      attorney, and EasyILA is not a substitute for the advice
                      of a licensed attorney.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Accounts and Information
                    </h2>

                    <h2 class="terms_condition_1">
                      4. Accounts and Information
                    </h2>
                    <p class="terms_text">
                      4.1. Your EasyILA Account. In order to access and use some
                      aspects of the Site and Services, you will be required to
                      create an account and establish a username and password.
                      If you create a EasyILA Account, you agree to submit only
                      accurate information about yourself and to keep the
                      information you submit up-to-date. You agree not to
                      impersonate anyone else. You are responsible for
                      maintaining the security and confidentiality of your
                      username and password, and you agree not to authorize
                      anyone else to use your username and password. You are
                      solely responsible for all actions taken under your
                      account. You agree to notify EasyILA promptly in the event
                      you learn of any unauthorized use of your account. By
                      creating an account, you agree that you may receive
                      electronic communications from EasyILA and its affiliates,
                      including offers, newsletters, account notices and
                      updates. If at any time you no longer wish to receive such
                      electronic communications, you may opt-out by clicking the
                      designated link in the communication.
                    </p>

                    <p class="terms_text">
                      4.2. Your Application. If you purchase a service from us
                      and file an application, we may assign a unique email
                      address to your account for the sole purpose of enabling
                      EasyILA to receive directly from USCIS the receipt number
                      assigned to your application. You agree that EasyILA may
                      use your receipt number to check your application status
                      from time to time so that we may provide you pertinent
                      general information about the steps in the application
                      process. If, at any time, you do not want EasyILA to
                      retain your receipt number or to check your application
                      status, let us know by contacting our customer service
                      department at support@easyila.com. Likewise, same is for
                      applications, processes and services requested with other
                      departments, organizations, persons, countries,
                      governments, entities and the like. Some of the service
                      requests you make may not require creating an account with
                      easyILA.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      You may need to create an account with EasyILA. If you do,
                      you will only provide accurate information about yourself.
                      You agree not to share your account access credentials
                      with others, and will be responsible for anyone's use of
                      your account. When you create an account, you give us
                      permission to receive your government receipt number, use
                      that number to check your application status, and email
                      you with offers, newsletters, and general information
                      about the application process. If you don't want us to
                      retain your government receipt number or check your
                      application status, email us at support@easyila.com. If
                      you don't want us to email you with offers and
                      newsletters, you can unsubscribe using the link in any
                      email we send to you. Likewise you give us permission to
                      do the needed for applications, processes and services
                      that involve other departments of other government or
                      private entities. Some of these service requests do not
                      require creating an account with easyila.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Use of Services
                    </h2>

                    <h2 class="terms_condition_1">
                      Access to and Use of Site and Services
                    </h2>
                    <p class="terms_text">
                      5.1. License Grant to You. Subject to your complete
                      compliance with the provisions of this Agreement, you are
                      granted a limited, non-exclusive, non-transferable,
                      revocable license to use the Site and Services solely in
                      the manner authorized and intended by EasyILA. Any rights
                      not expressly granted in this Agreement are expressly
                      reserved by EasyILA. The resale or distribution of
                      materials made available on the Site without the express,
                      written consent of EasyILA is prohibited. All such
                      materials are authorized only for your own personal use.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      We are granting you permission to use our website and
                      services, but only in the ways described in this
                      agreement. You can't transfer this permission to others.
                      You can't sell or give the information or content we
                      provide to you to others.
                    </p>

                    <h2 class="terms_condition_1">
                      5.2. Restrictions on Your Access To and Use of Site and
                      Services
                    </h2>
                    <p class="terms_text">
                      In connection with your access to or use of the Site or
                      Services, you are prohibited from:
                    </p>

                    <ul
                      style={{
                        float: "left",
                        width: "100%",
                      }}
                    >
                      <li class="terms_text">
                        accessing data not intended for you or logging onto a
                        server or an account which you are not authorized to
                        access;
                      </li>
                      <li class="terms_text">
                        using any engine, software, tool, agent or other device
                        or mechanism (including without limitation browsers,
                        spiders, robots, avatars or intelligent agents) to
                        access, navigate, or search the Site, other than
                        generally available third-party web browsers (e.g.,
                        Mozilla Firefox, Google Chrome and Microsoft Explorer);
                      </li>
                      <li class="terms_text">
                        using any device, software or routine to interfere or
                        attempt to interfere with the proper working of the Site
                        or any activity being conducted on the Site;
                      </li>
                      <li class="terms_text">
                        attempting to interfere with service to any user, host
                        or network, including, without limitation, via means of
                        submitting a virus to the Site or through the Service,
                        overloading, "flooding," "spamming," "mailbombing" or
                        "crashing";
                      </li>
                      <li class="terms_text">
                        sending unsolicited email, including promotions and/or
                        advertising of products or services;
                      </li>
                      <li class="terms_text">
                        forging any TCP/IP packet header or any part of the
                        header information in any email or newsgroup posting;
                      </li>
                      <li class="terms_text">
                        copying, modifying, adapting, reproducing, reverse
                        engineering, decompiling, disassembling, or preparing
                        derivative works from EasyILA software, EasyILA Content
                        or User Content that is not your own;
                      </li>
                      <li class="terms_text">
                        distributing viruses, malicious code, malware or any
                        other technologies that may harm EasyILA, the Site, the
                        Services or a user;
                      </li>
                      <li class="terms_text">
                        violating or circumventing any applicable laws,
                        regulations or EasyILA technical measures, security
                        measures or policies;
                      </li>
                      <li class="terms_text">
                        violating, infringing, or breaching the rights of
                        EasyILA or a third-party, including, but not limited to
                        any copyrights, trademark rights, patent rights, trade
                        secrets rights, rights of publicity or personality,
                        moral rights, or any other proprietary rights;
                      </li>
                      <li class="terms_text">
                        submitting to the Site or through the Services any
                        false, inaccurate, misleading, deceptive, defamatory, or
                        libelous materials or User Content; or
                      </li>
                      <li class="terms_text">
                        knowingly withholding or failing to disclose information
                        requested by EasyILA or required to be included or
                        disclosed on a USCIS form or other government form or
                        engaging in any action that constitutes fraud.
                      </li>
                    </ul>

                    <p class="terms_text">
                      Submitting false, inaccurate, misleading or deceptive
                      information, or failing to disclose information requested
                      by EasyILA or required to be included or disclosed on a
                      USCIS form or other government form may result in your
                      application being denied by the applicable government
                      agency and EasyILA will not have any liability to you as a
                      result of such actions.
                    </p>

                    <p class="terms_text">
                      Violations of system or network security may result in
                      civil or criminal liability. EasyILA will investigate
                      occurrences that may involve such violations and may
                      involve, and cooperate with, law enforcement authorities
                      in prosecuting users who are involved in such violations.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      Even though we are giving you permission to use our
                      website and services, there are a number of things you are
                      not allowed to do. These include things such gaining
                      access through certain prohibited means, interfering with
                      other users, breaking the law, or introducing viruses into
                      our website and systems. If you do some of these things,
                      we may inform authorities, and you may incur legal
                      liability.
                    </p>

                    <p class="terms_text">
                      5.3. License Grant by You. When you transmit any
                      information, content, materials or data to or through the
                      Site or Services, other than information, content,
                      materials or data submitted for the purpose of creating
                      your account or for preparing applications and/or forms
                      ("User Content"), you hereby grant EasyILA and its
                      affiliates a non-exclusive, royalty-free, perpetual,
                      irrevocable and fully sublicensable right to use,
                      reproduce, modify, adapt, publish, translate, create
                      derivative works from, distribute, perform and display
                      such User Content, including throughout the world in any
                      media. EasyILA shall have no obligation to: (a) maintain
                      any User Content you submit; (b) pay you any compensation
                      of any kind for any User Content; or (c) respond to any
                      User Content you submit. You represent and warrant that
                      you own or have obtained all necessary rights and/or
                      licenses to User Content that you submit, and that
                      EasyILA' use of such User Content does not violate or
                      infringe upon the rights of any person or entity.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      Some of the services we offer require you to provide us
                      information. We may also allow you to publish information
                      or materials on our website at your option. If you provide
                      us information or materials, you grant us the right to use
                      and process the information without any further permission
                      from you and without compensation to you. You acknowledge
                      that you own or have the right to provide us with any
                      information you submit.
                    </p>

                    <h2 class="terms_condition_1">Service Fees</h2>

                    <h2 class="terms_condition_1">6. Service Fees</h2>

                    <h2 class="terms_condition_1">6.1. Service Fees.</h2>
                    <p class="terms_text">
                      While EasyILA makes a large amount of information
                      available without cost, it charges fees for some of its
                      services ("Service Fees"). All Service Fees will be set
                      forth on the Site. USCIS and other agencies charge fees
                      for the filing and processing of various government forms
                      ("Government Fees"). Government Fees are separate from our
                      Service Fees and must be paid to the applicable government
                      agency at the time of filing.{" "}
                      <b>
                        Unless you have included the USCIS fee payment option
                        with your application, or we indicate otherwise, you
                        remain responsible for paying Government Fees directly
                        to the applicable government agency
                      </b>
                      .
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      We charge fees for some services. Those fees will be
                      listed on our website. Our fees do not include separate
                      fees charged by USCIS or other government agencies, which
                      we will clearly communicate to you.
                    </p>

                    <h2 class="terms_condition_1">
                      6.2. Payment of Service Fees.
                    </h2>
                    <p class="terms_text">
                      When you purchase services for which Service Fees apply,
                      you will be required to provide EasyILA with valid,
                      up-to-date credit card or other payment information. You
                      authorize EasyILA to charge your credit card or other
                      payment method for all Service Fees you incur as they
                      become due and payable. You are responsible for
                      maintaining up-to-date payment information. If we cannot
                      charge you for Service Fees when due because your payment
                      information is incorrect or no longer valid, or if we do
                      not receive your payment when due, EasyILA will have no
                      obligation to provide the services associated with those
                      Service Fees.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      To pay for our services, you'll need to use a credit card
                      or other approved method of payment. We require accurate
                      information about your payment method in order to process
                      payment. If we can't process your payment, we don't have
                      to provide services to you.
                    </p>

                    <h2 class="terms_condition_1">6.3. Refunds/Credits.</h2>
                    <p class="terms_text">
                      Please refer to our refund policy. The determination of
                      whether to issue a refund or credit more than 30 days
                      after your purchase of services, other than a refund due
                      to a billing error by EasyILA, shall be made in EasyILA'
                      sole discretion, in good faith, and we reserve the right
                      to deny a request a refund or credit.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      In the unlikely event you're not happy with our services,
                      please contact us. We'll try to resolve the issue and we
                      may provide a refund or issue a credit if appropriate.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Intellectual Property Rights
                    </h2>

                    <h2 class="terms_condition_1">
                      7. Ownership and Intellectual Property Rights
                    </h2>
                    <p class="terms_text">
                      All materials, including text, images, videos,
                      illustrations, designs, icons, photographs, software,
                      programs and written and other materials that are part of
                      the Site or accessible through the Services, other than
                      User Content (collectively, "EasyILA Content"), is the
                      property of EasyILA or its licensors. EasyILA Content is
                      intended solely for personal, non-commercial use. No
                      right, title or interest in any EasyILA Content is
                      transferred to you by way of this Agreement or otherwise.
                      You may not reproduce (except as noted above), publish,
                      transmit, distribute, display, modify, create derivative
                      works from, sell or participate in any sale of or exploit
                      in any way, in whole or in part, any of the EasyILA
                      Content, the Site or any related software. EASYILA and the
                      EasyILA Logo are trademarks of EasyILA and or esmsys and
                      or their respective owners. Some content, images, icons,
                      illustrations, photos, design, etc may belong to others
                      and remain their copyright and or due ownership.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      Our website (including software underlying the website)
                      and its contents are owned by EasyILA or others who have
                      given EasyILA permission to use the contents. While we are
                      giving you permission to use our website, we are not
                      transferring any ownership of the website or its contents
                      to you. You are not allowed to make copies of our website
                      or its contents.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Copyright Infringement
                    </h2>

                    <h2 class="terms_condition_1">
                      8. Copyright Infringement (Digital Millennium Copyright
                      Act)
                    </h2>
                    <p class="terms_text">
                      EasyILA respects the intellectual property of others. We
                      strive to respond promptly to proper notices of copyright
                      infringement by removing or disabling access to allegedly
                      infringing material. It is EasyILA' policy to terminate
                      the access privileges of those who repeatedly infringe the
                      copyrights of others.
                    </p>

                    <p class="terms_text">
                      Submitting a Copyright Infringement Notification. If you
                      believe that any material appears on the Site in a way
                      that infringes the copyright in a work owned by you,
                      please send a notification containing the following
                      information to EasyILA' Copyright Agent:
                    </p>

                    <ul
                      style={{
                        float: "left",
                        width: "100%",
                        paddingLeft: "25px",
                      }}
                    >
                      <li class="terms_text">
                        an electronic or physical signature of the person
                        authorized to act on behalf of the owner of the
                        copyright interest;
                      </li>
                      <li class="terms_text">
                        a description of the work in which you hold a copyright
                        interest which you believe is being infringed;
                      </li>
                      <li class="terms_text">
                        a description of the location on this website where the
                        allegedly infringing material is located (preferably
                        including a URL address);
                      </li>
                      <li class="terms_text">
                        your address, telephone number, and email address;
                      </li>
                      <li class="terms_text">
                        a statement by you that you have a good faith belief
                        that the disputed use is not authorized by the copyright
                        owner, its agent, or the law; and
                      </li>
                      <li class="terms_text">
                        a statement by you, made under penalty of perjury, that
                        the above information in your notification is accurate
                        and that you are the copyright owner or authorized to
                        act on the copyright owner's behalf.
                      </li>
                    </ul>

                    <p class="terms_text">
                      EasyILA' Copyright Agent can be reached at the following
                      address:
                    </p>
                    <p class="terms_text">EasyILA</p>
                    <p class="terms_text">esmsys</p>
                    <p class="terms_text">
                      A/B-402, TIMES SQUARE GRAND, Sindhu Bhavan Marg, PRL
                      Colony, Thaltej, Ahmedabad, Gujarat 380059
                    </p>
                    <p class="terms_text">Attn: Copyright Agent</p>
                    <p class="terms_text">support@easyila.com</p>

                    <p class="terms_text">
                      When EasyILA removes material or disables access to
                      material in response to an infringement notification,
                      EasyILA will make a reasonable attempt to contact the
                      allegedly infringing party, provide information about the
                      notification and removal, and provide information about
                      submitting a counter-notification. EasyILA may also
                      provide a copy of the infringement notification to the
                      allegedly infringing party.
                    </p>

                    <p class="terms_text">
                      Submitting a Counter-Notification. If you believe that any
                      material identified in a copyright infringement
                      notification is not infringing, or that you have the
                      authorization from the copyright owner, from the copyright
                      owner's agent, or pursuant to the law, to post and use the
                      material complained of, you may send a
                      counter-notification containing the following information
                      to EasyILA' Copyright Agent (identified above):
                    </p>

                    <ul
                      style={{
                        float: "left",
                        width: "100%",
                        paddingLeft: "25px",
                      }}
                    >
                      <li class="terms_text">
                        your physical or electronic signature;
                      </li>
                      <li class="terms_text">
                        identification of the material that has been removed or
                        to which access has been disabled, and the location at
                        which the material appeared before it was removed or
                        disabled;
                      </li>
                      <li class="terms_text">
                        a statement that you have a good faith belief that the
                        material was removed or disabled as a result of mistake
                        or a misidentification of the material; and
                      </li>
                      <li class="terms_text">
                        your name, address, telephone number, and e-mail
                        address, a statement that you consent to the
                        jurisdiction of the federal court in the New Jersey, and
                        a statement that you will accept service of process from
                        the person who provided notification of the alleged
                        infringement.
                      </li>
                    </ul>

                    <p class="terms_text">
                      If EasyILA receives a counter-notification, we may send a
                      copy of the counter-notification to the original
                      complaining party informing that person that we may
                      replace the removed material or cease disabling it in 10
                      business days. Unless the original complaining party files
                      an action seeking a court order against the person who
                      provided the allegedly infringing material, the removed
                      material may be replaced, or access to it restored, 14
                      business days or more after receipt of the
                      counter-notification, at EasyILA' sole discretion.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      The Digital Millennium Copyright Act ("DMCA") is a U.S.
                      law that provides a method for copyright owners to object
                      to unauthorized use of their materials by others,
                      including website operators such as EasyILA. If you think
                      material owned by you and protected under copyright laws
                      is being used by EasyILA without your authorization, you
                      can follow the steps outlined above to notify us.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Third Party Services
                    </h2>

                    <h2 class="terms_condition_1">
                      9. Third Parties; Third Party Content and Services
                    </h2>
                    <p class="terms_text">
                      References on the Site to any third parties, including
                      persons or companies, and to any products or services of
                      such third parties, are provided solely as a convenience
                      to you. EasyILA does not endorse, recommend, approve of or
                      make any representations or warranties regarding any third
                      parties or their products or services. Without limiting
                      the foregoing, EasyILA is not a lawyer referral service,
                      and makes no representations or warranties regarding any
                      law firms or attorneys that may be referenced on the Site,
                      including whether any such law firm or attorney is
                      licensed, qualified, competent or otherwise capable of
                      providing adequate legal advice regarding your specific
                      legal issues. EasyILA may provide links to third-party
                      websites. EasyILA is not responsible for the content of
                      any third-party websites and does not make any
                      representations regarding the content or accuracy of
                      material on such websites. If you decide to follow a link
                      to any third-party website, you do so entirely at your own
                      risk.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      We may reference other people or companies on our website,
                      including attorneys or law firms, and we may provide links
                      to other websites, including law firm websites. However,
                      by doing so, we're not stating our approval of those other
                      people, companies or websites, nor are we making any
                      promises about them. We are not a lawyer referral service.
                      If you visit a website we link to, we are not responsible
                      for anything that occurs with respect to your access or
                      use of that website.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Warranty
                    </h2>

                    <h2 class="terms_condition_1">
                      10. Disclaimer of Warranty
                    </h2>
                    <p class="terms_text">
                      THE SITE AND THE SERVICES ARE PROVIDED BY EASYILA ON AN
                      "AS IS" AND "AS AVAILABLE" BASIS. EASYILA MAKES NO
                      REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR
                      IMPLIED, AS TO THE SITE, SERVICES, OR INFORMATION,
                      CONTENT, OR MATERIALS OFFERED ON THE SITE OR THROUGH THE
                      SERVICES. TO THE FULLEST EXTENT PERMISSIBLE BY APPLICABLE
                      LAW, EASYILA DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
                      INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                      MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR A
                      PARTICULAR PURPOSE. EASYILA DOES NOT WARRANT THAT THE SITE
                      OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL
                      COMPONENTS. YOU AGREE THAT YOUR USE OF THE SITE AND THE
                      SERVICES IS AT YOUR SOLE RISK. THIS DISCLAIMER CONSTITUTES
                      AN ESSENTIAL PART OF THIS AGREEMENT, AND YOU ACKNOWLEDGE
                      THAT EASYILA WOULD NOT HAVE ENTERED INTO THIS AGREEMENT
                      WITH YOU WITHOUT YOUR AGREEMENT TO THE TERMS OF THIS
                      DISCLAIMER. THIS DISCLAIMER OF WARRANTY DOES NOT APPLY TO
                      THE PURCHASE OF SERVICES BY NORTH CAROLINA CONSUMERS.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      We make no promises about the website or services we
                      provide, and do not guarantee that our services are right
                      for you. You are responsible for determining whether or
                      not you should use our website or services. While we
                      strive to provide accurate information, we can't guarantee
                      that our information will always be up to date or
                      error-free. If you do use our website or services, you do
                      so at your own risk.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Liability
                    </h2>

                    <h2 class="terms_condition_1">
                      11. Limitation of Liability
                    </h2>
                    <p class="terms_text">
                      UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL OR EQUITABLE
                      THEORY, WHETHER IN TORT, CONTRACT, STRICT LIABILITY OR
                      OTHERWISE, SHALL EASYILA, ITS AFFILIATES, AND THEIR
                      RESPECTIVE EMPLOYEES, DIRECTORS, OFFICERS, AND AGENTS BE
                      LIABLE TO YOU OR TO ANY OTHER PERSON FOR ANY INDIRECT,
                      SPECIAL, INCIDENTAL OR CONSEQUENTIAL LOSSES OR DAMAGES OF
                      ANY NATURE ARISING OUT OF OR IN CONNECTION WITH THE USE OF
                      OR INABILITY TO USE THE SITE OR SERVICES, INCLUDING,
                      WITHOUT LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF
                      GOODWILL, LOSS OF DATA, ACCURACY OF RESULTS, OR COMPUTER
                      FAILURE OR MALFUNCTION, EVEN IF EASYILA, ITS AFFILIATES,
                      OR THEIR RESPECTIVE EMPLOYEES, DIRECTORS, OFFICERS, AND
                      AGENTS HAVE BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE
                      POSSIBILITY OF SUCH LOSSES OR DAMAGES. IN NO EVENT WILL
                      EASYILA BE LIABLE FOR ANY DAMAGES IN EXCESS OF THE FEES
                      PAID BY YOU IN CONNECTION WITH YOUR USE OF THE SITE OR
                      SERVICES DURING THE SIX MONTH PERIOD PRECEDING THE DATE ON
                      WHICH THE CLAIM AROSE.
                    </p>

                    <p class="terms_text">
                      CERTAIN JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED
                      WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
                      DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE
                      ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT
                      APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS. THIS
                      LIMITATION OF LIABILITY DOES NOT APPLY TO NORTH CAROLINA
                      CONSUMERS.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      Our liability to you resulting from your use of our
                      website or services will be limited to the amount of fees
                      you paid to us during the six months immediately before
                      any event that you believe gives rise to our liability.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Indemnification
                    </h2>

                    <h2 class="terms_condition_1">12. Indemnification</h2>
                    <p class="terms_text">
                      You agree to defend, indemnify and hold harmless esmsys,
                      LLC, EasyILA, its affiliates, and their respective
                      directors, officers and employees from and against any and
                      all claims, damages, costs and expenses, including
                      attorneys' fees, arising from or related to your breach of
                      this Agreement, your improper use of the Site or Services,
                      or your breach of any applicable law or infringement of
                      the rights of a third party. EasyILA shall have the right
                      to participate in the defense of any such claim, at its
                      own cost. You may not settle or negotiate any claim that
                      results in liability to, or imposes any obligation upon,
                      EasyILA, financial or otherwise, without the written
                      consent of EasyILA.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      If you use our website or services in a manner that we
                      prohibit, or otherwise breach this Agreement, or you
                      violate applicable laws or the rights of third parties,
                      you will be responsible for covering any expenses we incur
                      (including attorneys' fees and other legal expenses) as a
                      result of your actions.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Termination
                    </h2>

                    <h2 class="terms_condition_1">13. Termination</h2>
                    <p class="terms_text">
                      This Agreement shall remain in force and effective unless
                      and until terminated as provided in this Section 13. You
                      may terminate this Agreement at any time by providing
                      written notice to EasyILA, via email to
                      support@easyila.com. Except where you terminate this
                      Agreement due to an uncured material breach of this
                      Agreement by EasyILA or where you terminate this Agreement
                      pursuant to our Satisfaction Guarantee within 30 days of
                      purchasing Services, EasyILA will have no obligation to
                      refund you any Service Fees previously paid to EasyILA for
                      the Services. EasyILA may terminate this Agreement
                      immediately with or without notice, and/or may deny you
                      access to the Site or Services, in EasyILA' sole
                      discretion, in the event you breach, or threaten to
                      breach, any term of this Agreement. If you have already
                      paid for Services and have been found to be in violation
                      of this Agreement, your account will be deleted without
                      notice and no refund of Service Fees will be made. Unless
                      otherwise agreed to by EasyILA in writing, this Agreement
                      shall terminate automatically on that date which is 12
                      months (or 24 months for petition combos) following the
                      date on which you initially purchased Services and no
                      Service Fees will be refunded.
                    </p>

                    <p class="terms_text">
                      Upon any termination of this Agreement, you must
                      immediately discontinue use of the Site and Services.
                      Sections 7 and 10-15 shall survive any termination of this
                      Agreement.
                    </p>

                    <h2 class="terms_condition_1">ONE LINER</h2>
                    <p class="terms_text">
                      Both of us have the right to terminate this Agreement by
                      providing notice to the other. If this Agreement is
                      terminated, you must stop using our website and services.
                    </p>

                    <h2 class="terms_condition_1" style={{ fontSize: "24px" }}>
                      Dispute Resolution
                    </h2>

                    <h2 class="terms_condition_1">
                      14. Dispute Resolution by Binding Arbitration
                    </h2>
                    <p class="terms_text">
                      Please read this carefully. It affects your rights.
                    </p>

                    <p class="terms_text">Summary:</p>
                    <p class="terms_text">
                      We believe customer concerns can be resolved quickly by
                      emailing our Customer Care Center at support@easyila.com.
                      If EasyILA is unable to resolve your complaint to your
                      satisfaction (or if we have not been able to resolve a
                      dispute with you after trying to do so informally), we
                      each agree to resolve such disputes through binding
                      arbitration or in small claims court, rather than in a
                      court of general jurisdiction. Arbitration is less formal
                      than a lawsuit in court. Arbitration uses a neutral
                      arbitrator instead of a judge or jury, limits discovery,
                      and is subject to very limited review by courts. Any
                      arbitration under this Agreement will take place on an
                      individual basis; class arbitrations and class actions are
                      not permitted.
                    </p>

                    <p class="terms_text">
                      For any non-frivolous claim that does not exceed $1,000,
                      EasyILA will pay all costs of the arbitration. Under
                      certain circumstances as explained below, we will pay you
                      more than the amount of the arbitrator's award. If you
                      prevail in arbitration, you may recover attorney's fees
                      from EasyILA to the same extent or more as you would in
                      court. The arbitrator shall apply the same limitations
                      period that would apply in court.
                    </p>

                    <p class="terms_text">
                      14.1. EasyILA and you agree to arbitrate all disputes and
                      claims between us before a single arbitrator. The types of
                      disputes and claims we agree to arbitrate are intended to
                      be broadly interpreted and include, without limitation:
                    </p>
                    <ul
                      style={{
                        float: "left",
                        width: "100%",
                        paddingLeft: "25px",
                      }}
                    >
                      <li class="terms_text">
                        claims arising out of or relating to any aspect of the
                        relationship between us, whether based in contract,
                        tort, statute, fraud, misrepresentation, or any other
                        legal theory;
                      </li>
                      <li class="terms_text">
                        claims that arose before these or any prior Agreement
                        (including, but not limited to, claims relating to
                        advertising);
                      </li>
                      <li class="terms_text">
                        claims currently the subject of purported class action
                        litigation in which you are not a member of a certified
                        class; and
                      </li>
                      <li class="terms_text">
                        claims that may arise after the termination of this
                        Agreement.
                      </li>
                    </ul>
                    <p className="terms_text">
                      For the purposes of this Arbitration Agreement, references
                      to "EasyILA," "you," and "us" include our respective
                      subsidiaries, affiliates, agents, employees, business
                      partners, predecessors in interest, successors, and
                      assigns, as well as all authorized or unauthorized users
                      or beneficiaries of services or products under this
                      Agreement or any prior agreements between us.
                      Beneficiaries include, but are not limited to, those
                      seeking to change immigration status and any relatives.
                    </p>
                    <p className="terms_text">
                      For the purposes of this Arbitration Agreement, references
                      to "EasyILA," "you," and "us" include our respective
                      subsidiaries, affiliates, agents, employees, business
                      partners, predecessors in interest, successors, and
                      assigns, as well as all authorized or unauthorized users
                      or beneficiaries of services or products under this
                      Agreement or any prior agreements between us.
                      Beneficiaries include, but are not limited to, those
                      seeking to change immigration status and any relatives.
                    </p>
                    <p className="terms_text">
                      Notwithstanding the foregoing, either party may bring an
                      individual action in small claims court or in a court of
                      proper jurisdiction seeking injunctive relief ancillary to
                      arbitration. This Arbitration Agreement does not preclude
                      your bringing issues to the attention of federal, state,
                      or local agencies. Such agencies can, if the law allows,
                      seek relief against us on your behalf. You agree that, by
                      entering into this Agreement, you and EasyILA are each
                      waiving the right to a trial by jury or to participate in
                      a class action or class or mass arbitration. This
                      Agreement evidences a transaction or website use in
                      interstate commerce, and thus the Federal Arbitration Act
                      ("FAA") governs the interpretation and enforcement of this
                      provision. This arbitration provision will survive
                      termination of this Agreement.
                    </p>
                    <p className="terms_text">
                      14.2. A party who intends to seek arbitration must first
                      send, by U.S. certified mail, a written Notice of Dispute
                      ("Notice") to the other party. A Notice to EasyILA should
                      be addressed to: Notice of Dispute, easyILA, esmsys, LLC,
                      20h Andover Circle, Princeton, NJ 08540 (the "Notice
                      Address"). The Notice must (a) describe the nature and
                      basis of the claim or dispute and (b) set forth the
                      specific relief sought ("Demand"). If EasyILA and you do
                      not resolve the claim within 30 days after the Notice is
                      received, you or EasyILA may commence an arbitration
                      proceeding. During the arbitration, the amount of any
                      settlement offer made by EasyILA or you shall not be
                      disclosed to the arbitrator until after the arbitrator
                      determines the amount, if any, to which you or EasyILA is
                      entitled.
                    </p>
                    <p className="terms_text">
                      You may download or copy a form to initiate arbitration
                      from the AAA website, including for California residents,
                      at <a href="https://www.adr.org">https://www.adr.org</a>.
                    </p>
                    <p className="terms_text">
                      14.3. After we receive notice at the Notice Address that
                      you have commenced arbitration, we will promptly reimburse
                      you for your payment of the filing fee, unless your claim
                      is for more than $1,000 (excluding attorney's fees and
                      expenses). (Currently, the filing fee for
                      consumer-initiated arbitrations is $200, but this is
                      subject to change by the arbitration provider. If you are
                      unable to pay this fee, EasyILA will pay it directly after
                      receiving a written request at the Notice Address.) If,
                      however, the arbitrator finds that either the substance of
                      your claim or the relief sought in the Demand is frivolous
                      or brought for an improper purpose (as measured by the
                      standards set forth in Federal Rule of Civil Procedure
                      11(b)), then the payment of all such fees will be governed
                      by the AAA Rules. In such case, you agree to reimburse
                      EasyILA for all monies previously disbursed by it that are
                      otherwise your obligation to pay under the AAA Rules. The
                      arbitration will be governed by the Consumer Arbitration
                      Rules (the "AAA Rules") of the American Arbitration
                      Association (the "AAA"), as modified by this Agreement,
                      and will be administered by the AAA. The AAA Rules are
                      available online at www.adr.org or by calling the AAA at
                      1-800-778-7879. The arbitrator is bound by this Agreement.
                      All issues are for the arbitrator to decide, except that
                      issues relating to the scope, enforceability, and
                      interpretation of the arbitration provision and the scope,
                      enforceability, and interpretation of paragraph (f) are
                      for the court to decide. Unless EasyILA and you agree
                      otherwise, any arbitration hearing(s) will take place in
                      the county (or parish) of your contact address. If your
                      claim is for $500 or less, you may choose whether to
                      conduct the arbitration solely on the basis of documents
                      submitted to the arbitrator, by a telephonic hearing, or
                      by an in-person hearing as established by the AAA Rules.
                      If you choose to proceed either in person or by telephone,
                      we may choose to respond only by telephone or submission.
                      If your claim exceeds $500, the AAA Rules will determine
                      whether you have a right to a hearing. The parties agree
                      that in any arbitration of a dispute or claim, neither
                      party will rely for preclusive effect on any award or
                      finding of fact or conclusion of law made in any other
                      arbitration of any dispute or claim to which easyILA was a
                      party.
                    </p>
                    <p className="terms_text">
                      14.4. If the arbitrator issues an award in your favor that
                      is greater than the value of our last written settlement
                      offer made before an arbitrator was selected, easyILA
                      will:
                    </p>
                    <ul
                      style={{
                        float: "left",
                        width: "100%",
                        paddingLeft: "25px",
                      }}
                    >
                      <li className="terms_text">
                        pay you either the amount of the award or $500 ("the
                        Alternative Payment"), whichever is greater; and
                      </li>
                      <li className="terms_text">
                        pay your attorney, if any, the amount of attorney's
                        fees, and reimburse any expenses (including expert
                        witness fees and costs), that your attorney reasonably
                        accrues for investigating, preparing, and pursuing your
                        claim in arbitration (the "Attorney's Payment").
                      </li>
                    </ul>

                    <p className="terms_text">
                      If EasyILA did not make a written offer to settle the
                      dispute before an arbitrator was selected, you and your
                      attorney will be entitled to receive the Alternative
                      Payment and the Attorney's Payment, respectively, if the
                      arbitrator awards you any relief on the merits. The
                      arbitrator may make rulings and resolve disputes as to the
                      payment and reimbursement of fees, expenses, and the
                      alternative payment and the attorney's fees at any time
                      during the proceeding and upon request from either party
                      made within 14 days of the arbitrator's ruling on the
                      merits. In assessing whether an award that includes
                      attorney's fees or expenses is greater than the value of
                      our last written settlement offer, the arbitrator shall
                      include in his or her calculations only the value of any
                      attorney's fees or expenses you reasonably incurred in
                      connection with the arbitration proceeding before our
                      settlement offer.
                    </p>
                    <p className="terms_text">
                      14.5. The right to attorney's fees and expenses discussed
                      in paragraph (d) supplements any right to attorney's fees
                      and expenses you may have under applicable law. Thus, if
                      you would be entitled to a larger amount under applicable
                      law, this provision does not preclude the arbitrator from
                      awarding you that amount. However, you may not recover
                      duplicative awards of attorney's fees or costs. Although
                      under some laws we may have a right to an award of
                      attorney's fees and expenses from you if we prevail in an
                      arbitration proceeding, we will not seek such an award.
                    </p>
                    <p className="terms_text">
                      14.6. YOU AND EASYILA AGREE THAT EACH MAY BRING CLAIMS
                      AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL
                      CAPACITIES AND NOT AS PLAINTIFFS OR CLASS MEMBERS IN ANY
                      PURPORTED CLASS OR REPRESENTATIVE PROCEEDING OR IN THE
                      CAPACITY OF A PRIVATE ATTORNEY GENERAL, INCLUDING IN
                      ARBITRATION. Unless both you and EasyILA agree otherwise,
                      the arbitrator may not consolidate more than one person's
                      claims, and may not otherwise preside over any form of a
                      representative or class proceeding. The arbitrator may
                      award any relief that a court could award that is
                      individualized to the claimant and would not affect other
                      customers. Neither you nor we may seek non-individualized
                      relief that would affect other customers. If a court
                      decides that applicable law precludes enforcement of any
                      of this paragraph's limitations as to a particular claim
                      for relief, then that claim (and only that claim) may be
                      severed from the arbitration and brought in court.
                    </p>
                    <p className="terms_text">
                      14.7. If the amount in dispute exceeds $1,000 (excluding
                      attorney's fees and expenses) either party may appeal the
                      award to a three-arbitrator panel administered by AAA by a
                      written notice of appeal within thirty (30) days from the
                      date of entry of the written arbitration award. The
                      members of the three-arbitrator panel will be selected
                      according to AAA rules. The three-arbitrator panel will
                      issue its decision within one hundred and twenty (120)
                      days of the date of the appealing party's notice of
                      appeal. The decision of the three-arbitrator panel shall
                      be final and binding, subject to any right of judicial
                      review that exists under the FAA.
                    </p>
                    <p className="terms_text">
                      14.8. Notwithstanding any provision in this Agreement or
                      elsewhere to the contrary, EasyILA agrees that if we make
                      any changes to this arbitration provision (other than a
                      change to any notice address, website link or telephone
                      number provided herein), that change will not apply to any
                      dispute of which we had written notice on the effective
                      date of the change. Moreover, if we seek to terminate this
                      Agreement, any such termination will not be effective as
                      to this Arbitration Agreement until at least thirty (30)
                      days after written notice of such termination is provided
                      to you, and shall not be effective as to disputes which
                      arose prior to the date of termination.
                    </p>
                    <p className="terms_text">
                      14.8. Notwithstanding any provision in this Agreement or
                      elsewhere to the contrary, EasyILA agrees that if we make
                      any changes to this arbitration provision (other than a
                      change to any notice address, website link or telephone
                      number provided herein), that change will not apply to any
                      dispute of which we had written notice on the effective
                      date of the change. Moreover, if we seek to terminate this
                      Agreement, any such termination will not be effective as
                      to this Arbitration Agreement until at least thirty (30)
                      days after written notice of such termination is provided
                      to you, and shall not be effective as to disputes which
                      arose prior to the date of termination.
                    </p>

                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      In the unlikely event you and EasyILA get into a dispute
                      that cannot be resolved amicably, we are both agreeing to
                      resolve that dispute through arbitration (or in small
                      claims court where applicable) and we are waiving our
                      rights to have a dispute resolved in a court of law, by a
                      jury, and any right that might otherwise exist to bring or
                      participate in a class action lawsuit.
                    </p>

                    <h2
                      className="terms_condition_1"
                      style={{ fontSize: "24px" }}
                    >
                      Miscellaneous
                    </h2>
                    <h2 className="terms_condition_1">
                      15. Miscellaneous Terms
                    </h2>
                    <p className="terms_text">
                      15.1. Consent to Electronic Communications. You consent to
                      receive communications from EasyILA electronically, and
                      you agree that all agreements, notices, disclosures and
                      other communications that EasyILA provides to you
                      electronically, via email, or on the Site, satisfy any
                      legal requirement that such communications or agreements
                      be in writing.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      You are agreeing that we can communicate with you
                      electronically.
                    </p>
                    <p className="terms_text">
                      15.2. Assignment. You may not assign your rights under
                      this Agreement without the prior written permission of
                      EasyILA and any attempt by you to do so shall be null and
                      void.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      This agreement is between you and EasyILA, and you can't
                      assign your rights under the Agreement to someone else.
                    </p>
                    <p className="terms_text">
                      15.3. Waiver. The waiver of a breach of any provision of
                      this Agreement will not operate or be interpreted as a
                      waiver of any other or subsequent breach.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      If either of us chooses not to take action for a breach of
                      this Agreement by the other, that doesn't mean that we are
                      waiving our right to take action for a separate breach.
                    </p>
                    <p className="terms_text">
                      15.4. Severability. If any provision of this Agreement is
                      held to be invalid or unenforceable for any reason, the
                      remaining provisions will continue in full force without
                      being impaired or invalidated in any way.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      If a court or arbitrator determines that a provision of
                      the Agreement is invalid, that doesn't affect the other
                      provisions.
                    </p>
                    <p className="terms_text">
                      15.5. Changes to Agreement. EasyILA may make changes to
                      this Agreement at any time. If we make any material
                      changes we will notify you via email if you have created
                      an account (sent to the e-mail address specified in your
                      account) or by posting the revised Agreement on the Site
                      prior to any changes becoming effective. You should review
                      our Agreement each time you access the Site or use the
                      Services. Your continued use of the Site or Services
                      following the posting of any changes or notice to you of
                      the changes constitutes your agreement to such changes.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      We might change these terms. If we make material changes,
                      we'll provide notice before the changes take effect. If
                      you use our website or services after the change takes
                      effect, you are agreeing to the new terms.
                    </p>
                    <p className="terms_text">
                      15.6. Governing Law. This Agreement will be construed in
                      accordance with and governed exclusively by the laws of
                      the State of New Jersey applicable to agreements made
                      among New Jersey residents and to be performed wholly
                      within such jurisdiction, regardless of the parties'
                      actual domiciles.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      The law of Washington state applies to this Agreement.
                    </p>
                    <p className="terms_text">
                      15.7. Entire Agreement. This Agreement, including all
                      agreements referred to and incorporated herein, sets forth
                      the entire understanding and agreement between you and
                      EasyILA, and supersedes any and all other oral or written
                      agreements or understandings between the parties.
                    </p>
                    <h2 className="terms_condition_1">ONE LINER</h2>
                    <p className="terms_text">
                      This Agreement is the entire agreement between us, and
                      there are no other terms to our agreement other than the
                      terms you see here.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Privacy Policy End */}

        {/* Footer Section Start */}
        {/* <footer>
                    <div className="container">
                        <div className="row">
                            <p
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    color: '#fff',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    padding: '0 20px',
                                }}
                            >
                                DISCLAIMER IN PART: (Read full Disclaimer here):
                                This site is not a substitute for hiring an
                                attorney or law firm and does not provide legal
                                advice. This site does not endorse or recommend
                                any participating third-party legal
                                professionals that pay to participate in
                                advertising. An attorney-client relationship is
                                not formed when calling the number on this site
                                or filling out a form. Services may not be
                                available for all legal categories. All persons
                                depicted in a photo or video are actors or
                                models or from unsplash.com and not clients of
                                any firm. WE ARE NOT A LEGAL FIRM OR AN
                                ACCREDITED ORGANIZATION. ALL IMMIGRATION MATTERS
                                SHOULD BE CONSULTED WITH IMMIGRATION ATTORNEYS
                                OR AS GUIDED BY USCIS FROM TIME TO TIME. WE DO
                                NOT REPRESENT USCIS. WE DO NOT GIVE ANY ADVICE,
                                OPINION, OR CONSULTANCY ON IMMIGRATION MATTERS.
                            </p>
                            <div className="col-lg-6 col-sm-6 col-xs-12">
                                <ul className="footer-links">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/privacypolicy">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-6 col-sm-6 col-xs-12">
                                <div className="copyright">
                                    <p>
                                        All copyrights reserved &copy; 2025 -
                                        easyILA
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
        <Footer />
        {/* Footer Section End */}

        {/* Go To Top Link */}
        <a href="#" className="back-to-top">
          <i className="lnr lnr-arrow-up"></i>
        </a>
      </div>
    </>
  );
};

export default NewTermsAndConditions;
